import React from "react";
import { Box } from "@mui/material";
import RenderDate from "../../../Common/Date/RenderDate";

function ActivityStatusDetails({ dateStart, dateEnd, duration, score }) {
    return (
        <Box className="card-content">
            <Box className="flex-container">
                <dl className="row-data">
                    <dt>Start</dt>
                    <dd>
                        <RenderDate date={dateStart || ""} />
                    </dd>
                </dl>

                {dateEnd && (
                    <dl className="row-data">
                        <dt>End</dt>
                        <dd>
                            <RenderDate date={dateEnd} />
                        </dd>
                    </dl>
                )}

                {duration?.total > 0 && (
                    <dl className="row-data">
                        <dt>Duration</dt>
                        <dd>{duration.total}</dd>
                    </dl>
                )}

                {score?.value > 0 && (
                    <dl className="row-data">
                        <dt>{score?.unit === "pa" ? "PA" : "CPD points"}</dt>
                        <dd>{score.value}</dd>
                    </dl>
                )}
            </Box>
        </Box>
    );
}

export default ActivityStatusDetails;
